import { render, staticRenderFns } from "./auto-withdraw-kbank.vue?vue&type=template&id=96a93e28&scoped=true&"
import script from "./auto-withdraw-kbank.vue?vue&type=script&lang=js&"
export * from "./auto-withdraw-kbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a93e28",
  null
  
)

export default component.exports